import React, { memo } from 'react';
import { SidebarBoundary } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/ui/sidebar-boundary/index.tsx';
import { SidebarContent } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-common/src/ui/sidebar-content/index.tsx';
import { Skeleton } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-settings-global-common/src/ui/skeleton/index.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazySidebarContent = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "async-jira-navigation-apps-sidebar-nav4-sidebar-global-settings-operations-settings" */ './main'
		),
);

const AsyncSidebar = () => {
	return (
		<SidebarBoundary
			id="nav4.sidebar.global-settings.operations-settings"
			packageName="jiraNavigationAppsSidebarNav4GlobalSettingsOperationsSettings"
			teamName="alexstrasza"
		>
			<SidebarContent
				currentPageName="operations"
				testId="navigation-apps-sidebar-nav4-sidebars-settings-global-operations.ui.sidebar-content"
			>
				<Placeholder
					name="nav4.sidebar.global-settings.operations-settings"
					fallback={<Skeleton />}
				>
					<LazySidebarContent />
				</Placeholder>
			</SidebarContent>
		</SidebarBoundary>
	);
};

export default memo(AsyncSidebar);
